export function updateDeviceInfo(platform, version) {
  return {
    type: 'UPDATE_DEVICE_INFO',
    payload: {
      platform: platform,
      version: version
    }
  };
}
